module.exports = __webpack_public_path__ + "static/kartik-fdb616110ad99c02afcaaf3b883283ba.jpg";